import { setGlobalState, useGlobalState } from '../store'
import { payToMint,maxMintPerUsers,saleStatus,saleType } from '../SpotizContractHelper'
import Alert from 'sweetalert2'
import nftcard from './../assets/spotiz-nft-01.png'

const Main = () => {
  const [itemCount] = useGlobalState('nftCart');
  const [connectedAccount] = useGlobalState('connectedAccount');

  const onMintNFT = async () => {
    Alert.fire({
      title: 'Minting...',
      html: 'Please wait we are requesting to MetaMask for Mint your NFT.',
      didOpen: async ()  => {
        Alert.showLoading()
        var response = await payToMint();
        if(response){
          
         Alert.fire({
            icon: 'success',
            title: "Done",
            timer: 5000,
            timerProgressBar: true,
            html:"<p>Minted successfully, You are able to see your minted NFT on opensea.</p>",
            
          });
        }
      }
    })
  }

  return (
    <div className="main-section pt-20">
      <div className='container mx-auto'>
        <div className="flex md-display justify-start items-left mx-auto py-10 md-pl-0">
          <div className="flex md-display ">
            <div className='block'>
            <img src={nftcard} alt="Spotization NFT" className="w-80 mt-5 rounded-md shadow-sm h-auto"/>
            </div>
          </div>
          <div className="flex md-display">
            <div className="flex-col justify-start items-left pl-10 md-pl-0">
              <h1 className="text-white text-5xl font-bold text-left">
              <span className="text-gradient">Spotization</span><br/> NFT Collection
              </h1>
              <p className="text-white font-semibold text-sm mt-3">
                  {
                    (saleStatus)?(
                      <div className='w-[500px] block'>
                        <span>La vente privée est en ligne, cliquez sur le bouton ci-dessus pour frapper votre bon d’achat NFT Spotiz.</span>
                      </div>
                    ):<span className='w-[500px] block'>
                      Our {saleType} sale starts from Wednesday 18 January 2024 12:00 CET to Wednesday 25 January 2023 12:00 CET.
                    </span>
                  }
              </p>
              <div
                className={ (!saleStatus)?"flex flex-row opacity-[0.5]":"flex flex-row" }>
          
                <button  className=' flex flex-row justify-center items-center w-10 h-10 rounded-full bg-white cursor-pointer p-3 mt-5    hover:bg-[#000] hover:text-white transition-all duration-75 delay-100 font-bold'
                  onClick={() => {
                    if(saleStatus)
                    setGlobalState('nftCart',Math.max(itemCount - 1, 1));
                    else ""
                  }}
                  disabled={(!saleStatus)}>
                  {" - "}
                </button>

                <div
                  className=" flex flex-row
                  justify-center items-center w-5 h-10 rounded-full
              cursor-pointer p-2 mt-5 text-white"
                >
                  <span className="text-xs font-bold"><div color="secondary">
                      {itemCount}
                    </div>
                  </span>
                </div>
                
                <button className=' flex flex-row justify-center items-center w-10 h-10 rounded-full bg-white cursor-pointer p-3 mt-5    hover:bg-[#000] hover:text-white transition-all duration-75 delay-100 font-bold'
                  onClick={() => {
                    if((itemCount+connectedAccount.balance)<maxMintPerUsers && saleStatus){
                      setGlobalState('nftCart', itemCount + 1);
                    }
                  }}
                  disabled={(!saleStatus)} >
                  {" + "}
                </button> 
                <button
                className={" shadow-black ml-5 text-white  hover:bg-[#1e3fc0] p-3 pl-4 pr-4 rounded-full cursor-pointer my-5 text-xs font-bold " + (itemCount==0 ? ' bg-[#308fe8] shadow-xs' : '  bg-[#0c3895] shadow-sm' ) }
                onClick={() =>{
                  if(saleStatus){onMintNFT();}
                  
                }} >
                Mint Now
              </button>

              <div className='flex flex-row justify-center items-center w-[400px] ml-10 '>
                        <small className='font-small'>
                        Si vous voulez plus de 20 NFT, veuillez effectuer une nouvelle transaction. Ceci afin d'éviter d'allouer trop de ressources de la blockchain en même temps !</small>
                      </div>
              </div>
              <p className="text-white text-sm font-medium text-left max-w-lg">
              Afin de fédérer ses affiliés-associés autour de la Spotization et du montage des filiales de Spotiz. Nous avons décidé de mettre en place cette souscription de bons d’achats SPOT de Spotiz aux 50 affiliés-associés. Ce bon d’achat du Token SPOT permet d’utiliser la plateforme (paiement et confirmations des commandes de services, droit d'accès a la plateforme, droit de vote, droit de gouvernance), et de bénéficier d’avantages exclusifs en tant que 50 premiers associés - affilés.
              </p>         
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main
